<div *ngIf="loading" class="loading-text">
  <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
</div>

<div *ngIf="!loading">
<app-sub-header [pageTitle]="'Comment' | translate"></app-sub-header>

<div class="padded-container">
    <form (ngSubmit)="saveClick()">
      <dx-form>
        <dxi-item>
          <label>{{ 'Comment' | translate }}:</label>
          <div *ngFor="let comment of commentArray; let i = index">
            <dx-text-area
              [(ngModel)]="comment.driverComment"
              [name]="'comment' + i"
              [autoResizeEnabled]="true">
            </dx-text-area>
          </div>
        </dxi-item>
        <dxi-item>
          <dx-button class="full-width-button" text="{{ 'Save' | translate }}" type="success" (onClick)="saveClick()"></dx-button>
        </dxi-item>
        <dxi-item>
          <dx-button class="full-width-button" text="{{ 'Back' | translate }}" type="default" (onClick)="navigateToVoucher()"></dx-button>
        </dxi-item>
      </dx-form>
    </form>
</div>
</div>